import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';

interface PageExtraContextType {
  extra: ReactNode;
  setExtra: (node: ReactNode) => void;
}

const PageExtraContext = createContext<PageExtraContextType | null>(null);

export function PageExtraProvider({ children }: { children: ReactNode }) {
  const [extra, setExtra] = useState<ReactNode>(null);
  return (
    <PageExtraContext.Provider value={{ extra, setExtra }}>
      {children}
    </PageExtraContext.Provider>
  );
}

/**
 * Called from within a page's child component to inject action buttons
 * into the page header. Clears on unmount.
 */
export function usePageExtra(extra: ReactNode) {
  const ctx = useContext(PageExtraContext);
  useEffect(() => {
    ctx?.setExtra(extra);
    return () => { ctx?.setExtra(null); };
  }, [extra, ctx]);
}

export function usePageExtraValue(): ReactNode {
  return useContext(PageExtraContext)?.extra ?? null;
}
